<div class="main-container">
  <div class="grid-container" id="351report-grid-container" style="height: calc(100vh - 124px);">
    <div class="top-toolbar">
      <div class="toolbar-actions">
        @if (taxyearLoaded) {
<ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
  @for (item of taxYearItems; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
}
        <gtw-df-me-dropdown class="top-filter-select me-dropdown-label" [customActionCode]="32136"
          (selectedMes)="selectedMeChanged($event)">
        </gtw-df-me-dropdown>
        <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" (onClick)="loadReport()"></ap-button>
        <span class="toolbar-export" (click)="exportToExcel()">
          <span class="Appkit4-icon icon-save-outline"></span>
          <span>Export to Excel</span>
        </span>
      </div>
    </div>

    <div class="dst-mat-grid-layout">
      @if (loading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div class="dst-mat-grid">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #matSort="matSort"
               (matSortChange)="onMatSortChange()" class="dst-mat-table">

          <ng-container matColumnDef="STATEMENTID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[0])">{{ cols[0].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[0])">
              <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)">
                <span>{{ rowData.STATEMENTID }}</span>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="PROJECT_NAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[1])">{{ cols[1].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[1])">
              <span>{{ rowData.PROJECT_NAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[2])">{{ cols[2].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[2])">
              <span>{{ rowData.PRIMARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[3])">{{ cols[3].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[3])">
              <span>{{ rowData.PRIMARYENTITY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PRIMARYBUSINESS">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[4])">{{ cols[4].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[4])">
              <span>{{ rowData.PRIMARYBUSINESS }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="FILLING_GROUP">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[5])">{{ cols[5].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[5])">
              <span>{{ rowData.FILLING_GROUP }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SECONDARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[6])">{{ cols[6].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[6])">
              <span>{{ rowData.SECONDARYLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SECONDARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[7])">{{ cols[7].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[7])">
              <span>{{ rowData.SECONDARYENTITY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="DATE_OF_TRANSFER">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[8])">{{ cols[8].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[8])">
              <span gtwLineSplitter [inputString]="rowData.DATE_OF_TRANSFER" [sepearator]="'||'" [formatter]="'date'">
                {{ rowData.DATE_OF_TRANSFER }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="IMPORTATIONPROPERTYDESC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[9])">{{ cols[9].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[9])">
              <span>{{ rowData.IMPORTATIONPROPERTYDESC }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="LOSSDUPLICATIONPROPERTYDESC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[10])">{{ cols[10].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[10])">
              <span>{{ rowData.LOSSDUPLICATIONPROPERTYDESC }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="GAINLOSSPROPERTYDESC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[11])">{{ cols[11].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[11])">
              <span>{{ rowData.GAINLOSSPROPERTYDESC }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="DESCRIPTION">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[12])">{{ cols[12].header }}</th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[12])">
              <span gtwLineSplitter [inputString]="rowData.DESCRIPTION" [sepearator]="'||'">
                {{ rowData.DESCRIPTION }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="BASIS_AMOUNT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[13])">{{ cols[13].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[13])">
              <span gtwLineSplitter [inputString]="rowData.BASIS_AMOUNT" [sepearator]="'||'" [formatter]="'number'">
                {{ rowData.BASIS_AMOUNT }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="BASIS_CURRENCY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[14])">{{ cols[14].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[14])">
              <span>{{ rowData.BASIS_CURRENCY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="BASISTYPE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[15])">{{ cols[15].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[15])">
              <span>{{ rowData.BASISTYPE }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="FMV_AMOUNT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[16])">{{ cols[16].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[16])">
              <span gtwLineSplitter [inputString]="rowData.FMV_AMOUNT" [sepearator]="'||'" [formatter]="'number'">
                {{ rowData.FMV_AMOUNT }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="FMV_CURRENCY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[17])">{{ cols[17].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[17])">
              <span>{{ rowData.FMV_CURRENCY }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="STOCK_TYPE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[18])">{{ cols[18].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[18])">
              <span gtwLineSplitter [inputString]="rowData.STOCK_TYPE" [sepearator]="'||'">
                {{ rowData.STOCK_TYPE }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SHARE_X">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[19])">{{ cols[19].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[19])">
              <span gtwLineSplitter [inputString]="rowData.SHARE_X" [sepearator]="'||'" [formatter]="'number'">
                {{ rowData.SHARE_X }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PERCENTAGE_X">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[20])">{{ cols[20].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[20])">
              <span gtwLineSplitter [inputString]="rowData.PERCENTAGE_X" [sepearator]="'||'" [formatter]="'percent'">
                {{ rowData.PERCENTAGE_X }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="SHARE_Y">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[21])">{{ cols[21].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[21])">
              <span gtwLineSplitter [inputString]="rowData.SHARE_Y" [sepearator]="'||'" [formatter]="'number'">
                {{ rowData.SHARE_Y }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="PERCENTAGE_Y">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[22])">{{ cols[22].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[22])">
              <span gtwLineSplitter [inputString]="rowData.PERCENTAGE_Y" [sepearator]="'||'" [formatter]="'percent'">
                {{ rowData.PERCENTAGE_Y }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="LIABILITIES_DESC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[23])">{{ cols[23].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[23])">
              <span gtwLineSplitter [inputString]="rowData.LIABILITIES_DESC" [sepearator]="'||'">
                {{ rowData.LIABILITIES_DESC }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="LIABILITIESAMT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[24])">{{ cols[24].header }}</th>
            <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[24])">
              <span gtwLineSplitter [inputString]="rowData.LIABILITIESAMT" [sepearator]="'||'" [formatter]="'number'">
                {{ rowData.LIABILITIESAMT }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="IS_362E">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[25])">{{ cols[25].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[25])">
              <span>{{ rowData.IS_362E }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="IS_304">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[26])">{{ cols[26].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[26])">
              <span>{{ rowData.IS_304 }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="TARGETLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[27])">{{ cols[27].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[27])">
              <span>{{ rowData.TARGETLEID }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="TARGETNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[28])">{{ cols[28].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[28])">
              <span>{{ rowData.TARGETNAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="NOOFSHARES">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[29])">{{ cols[29].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[29])">
              <span gtwLineSplitter [inputString]="rowData.NOOFSHARES" [sepearator]="'||'" [formatter]="'number'">{{ rowData.NOOFSHARES }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="STOCKTRANSFERRED">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[30])">{{ cols[30].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[30])">
              <span>{{ rowData.STOCKTRANSFERRED }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="TRANSFEREESNOTE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[31])">{{ cols[31].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[31])">
              <span>{{ rowData.TRANSFEREESNOTE }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="AMTFOR351TRANSFER">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[32])">{{ cols[32].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[32])">
              <span gtwLineSplitter [inputString]="rowData.AMTFOR351TRANSFER" [sepearator]="'||'" [formatter]="'number'">{{ rowData.AMTFOR351TRANSFER }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="TRANSDESCRIPTION">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[33])">{{ cols[33].header }}</th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[33])">
              <span>{{ rowData.TRANSDESCRIPTION }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
        </table>
      </div>
    </div>
  </div>
</div>

@if (showModalViewer) {
<dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
</dst-disc-modal-viewer>
}
